/**
 * Formatação monetária única do companies-admin.
 * Prefixo fixo "R$" (sem código BRL). Não prefixar de novo no JSX.
 * Usado pelos módulos: fornecedores, estoque, cardápio, caixa, contas.
 */

/** Converte number/string (pt-BR, en-US, com ou sem R$/BRL) em number. */
export function parseMoney(value: number | string | undefined | null): number {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }
  if (value == null || value === "") return 0;

  let cleaned = String(value)
    .replace(/R\$\s?/gi, "")
    .replace(/BRL\s?/gi, "")
    .replace(/\s/g, "")
    .replace(/[^\d,.-]/g, "");

  if (!cleaned) return 0;

  const hasComma = cleaned.includes(",");
  const hasDot = cleaned.includes(".");

  if (hasComma && hasDot) {
    cleaned = cleaned.replace(/\./g, "").replace(",", ".");
  } else if (hasComma) {
    cleaned = cleaned.replace(",", ".");
  } else if (hasDot) {
    const parts = cleaned.split(".");
    const last = parts[parts.length - 1] ?? "";
    if (
      parts.length > 2 ||
      (parts.length === 2 && last.length === 3 && parts[0] !== "")
    ) {
      cleaned = cleaned.replace(/\./g, "");
    }
  }

  const num = Number.parseFloat(cleaned);
  return Number.isFinite(num) ? num : 0;
}

/** Formata valor em pt-BR com um único prefixo R$ (sem BRL). */
export function formatMoneyRs(
  value: number | string | undefined | null,
): string {
  const amount = parseMoney(value);
  return `R$ ${amount.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** Número pt-BR sem prefixo R$ (inputs de formulário). */
export function formatCurrencyInput(value: number | string): string {
  return parseMoney(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Aliases — mesmo helper; não reimplementar nos módulos. */
export const formatCurrency = formatMoneyRs;
export const formatCurrencyBr = formatMoneyRs;
export const formatMoney = formatMoneyRs;
export const parseCurrency = parseMoney;
export const parseCurrencyInput = parseMoney;
